<form [formGroup]="_filterForm">
  <div class="flex-container">
    <mat-form-field class="form-field flex-item">
      <mat-select [formControlName]="'orderCorporationID'" [placeholder]="'common.labels.corporation' | transloco">
        @for (option of _corporations; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-field flex-item">
      <mat-select [formControlName]="'orderTypes'" [placeholder]="'common.labels.orderType' | transloco" multiple="true">
        @for (option of _orderTypeOptions; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <lib-jurisdiction-selection (formReady)="jurisdictionFormChanges($event)" [defaultCountry]="'CA'"
    [multiSelect]="true" [countryFieldName]="'OrderCountries'"
  [jurisdictionFieldName]="'OrderJurisdictions'"></lib-jurisdiction-selection>

  <div class="flex-container">
    <mat-form-field class="form-field flex-item">
      <mat-label>{{ 'orderAuditFilter.auditDateFrom' | transloco }}</mat-label>
      <input matInput [matDatepicker]="auditDateFrom" [formControlName]="'auditDateFrom'"
        [placeholder]="'orderAuditFilter.auditDateFrom' | transloco">
      <mat-datepicker-toggle matSuffix [for]="auditDateFrom"></mat-datepicker-toggle>
      <mat-datepicker #auditDateFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="form-field flex-item">
      <mat-label>{{ 'orderAuditFilter.auditDateTo' | transloco }}</mat-label>
      <input matInput [matDatepicker]="auditDateTo" [formControlName]="'auditDateTo'" [placeholder]="'orderAuditFilter.auditDateTo' | transloco">
      <mat-datepicker-toggle matSuffix [for]="auditDateTo"></mat-datepicker-toggle>
      <mat-datepicker #auditDateTo></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="flex-container">
    <mat-form-field class="form-field flex-item">
      <mat-select [formControlName]="'auditStateID'" [placeholder]="'orderAuditFilter.auditState' | transloco">
        @for (option of _auditStateOptions; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="spacer-small"></div>

  <div>
    <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
      (click)="onClear()" [disabled]="!_filterForm.dirty">
      {{ 'common.labels.clearFilters' | transloco }}
    </button>
    <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
      (click)="onFilter()">
      {{ 'common.labels.filter' | transloco }}
    </button>
  </div>
</form>